import { Pagination } from 'antd';
import _, { cloneDeep, set } from 'lodash';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Row, Spinner, Toast } from 'reactstrap'
import { authSelector, setLoading } from '../../store/slices/auth';
import { CustomButton, showToaster, toasterTypes } from '../../widgets'
import ModalPopup from '../../widgets/modal';
import CustomTable from '../../widgets/table';
import { deleteRecord, deleteRecords, downloadFieldTemplate, downloadFormData, getFilteredFormRecords, getFormData, getFormRecords, getForms, getFormVariables, getMasterAiSummary, getRecordSummary, getRules, getSummaryData, getUniqueData, getVisualisationData, postgenerateLink, updateReviewApproveForm, uploadFileData, uploadFileDataStatus, uploadRecord } from './apiController';
import CreateForm from './CreateForm';
import ViewForm from './ViewForm';
import { ArrowLeftOutlined, CloudDownloadOutlined, DatabaseFilled, FileExcelFilled, FullscreenExitOutlined, FullscreenOutlined, ReloadOutlined } from '@ant-design/icons';
// import {exportAsExcelFile} from '../../utils/Excel';
import { saveAs } from 'file-saver';
import moment from 'moment';
import UidGenerateLink from './UidGenerateModal';
import { ColumnFilter } from '../../widgets/table/columnfilter';
import CustomFilter from './CustomFilter';
import ModalComponent from '../common/Modal/modal';
import { FIELD_TYPES, FieldItem } from '../../widgets/fields';
import useFieldItem from '../../widgets/fields/UseFieldItem';
import { copyData } from '../../utils/Utils';
import AskQuestions from './AskQuestions';
import PushToEditor from '../Editor/utils/PushToEditor';
import SectionModal from '../Editor/utils/SectionModal';
import { htmlToJSON } from '../Editor/utils/ContentType';
import GraphicWalkerVisualization from '../common/GraphicWalker_Visualization/GraphicWalkerVisualization';
import UploadStatusModal from './UploadStatusModal';
import DownloadStatusModal from './DownloadStatusModal';
import UidAddDataModal from './UidAddDataModal';
import MasterData from './MasterData';
import ViewRecordSummary from './ViewRecordSummary';
import EditRecordsVariableView from './EditRecordsVariableView';
import EditRecordsTableView from './EditRecordsTableView';
import SurveyFormComponent from '../surveyForm/SurveyFormComponent';
import PrintPdfComponent from './PrintPdfComponent';
import { agentNamesDataMap } from '../common/utils/aiAgentsData';
import { surveyUrl } from '../../environments/environment';
import SearchIndexTabs from './SearchIndexTabs';
import { convertUTCTimeToIST } from '../../utils/ConvertUTCToLocale';

export default function ViewFormData(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [action, setaction] = useState<any | "">("");
    const [isMasterData, setisMasterData] = useState<boolean>(false);;
    const [actionPush, setactionPush] = useState('');
    const [records, setrecords] = useState([]);
    const [columns, setcolumns] = useState([]);
    const [selectedRecords, SetSelectedRecords] = useState<any>("");
    const [selectedRow, setselectedRow] = useState<any | null>(null);
    const [responseData, setresponseData] = useState<any | []>([]);
    const [masterresponseData, setmasterresponseData] = useState<any | []>([]);
    const [formVariables, setformVariables] = useState<any | []>([]);
    const [isCallApi, setisCallApi] = useState(false);
    const [pageSize, SetPageSize] = useState(10);
    const [pageNo, SetPageNo] = useState<number>(1)
    const [selectedIndex, SetselectedIndex] = useState<any>(null);
    const [uploadStatus, SetUploadStatus] = useState(false)
    const [isPagination, setisPagination] = useState(true);
    const [customFilterData, setcustomFilterData] = useState<any>({});
    const [customFormatedFilterData, setcustomFormatedFilterData] = useState<any>({});
    const [pageCount, setpageCount] = useState(props.formPageCount);
    const [visualizationData, setVisualizationData] = useState<any | []>([]);
    const projectDataPerm = useSelector(authSelector)
    const [permissionData, setPermissionData] = useState({});
    const [moreOption, setmoreOption] = useState(false);
    const uploadFileRef = useRef<HTMLInputElement | null>(null);
    const [values, fields, handleChange, { validateValues, reset, updateValue, resetValue, updateError, updateAllError }] = useFieldItem({}, {}, { onValueChange });
    const [formData, setformData] = useState<any>([]);
    const [masterData, setmasterData] = useState<any>([]);
    const [rules, setRules] = useState<any>([]);
    const [refreshPage, setRefreshPage] = useState<number>(0);
    const [customNavigationState, setCustomNavigationState] = useState<any>(null);
    const [searchIndexUidData, setSearchIndexUidData] = useState<any>(null);

    const [isSplitView, setIsSplitView] = useState<boolean>(false);
    const [splitSelectedRecordIndex, setSplitSelectedRecordIndex] = useState<number | null>(null);
    const [splitSelectedTargetForm, setSplitSelectedTargetForm] = useState<any>("");
    const [splitAction, setSplitAction] = useState<any>("");
    const [splitCustomNavigationState, setSplitCustomNavigationState] = useState<any>(null);
    const [isImageMaximized, setIsImageMaximized] = useState(false);
    const [maximizedImageUrl, setMaximizedImageUrl] = useState("");
    const [maximizedImageTitle, setMaximizedImageTitle] = useState("");
    const [isSplitSelectionModalOpen, setIsSplitSelectionModalOpen] = useState<boolean>(false);
    const [splitTargetFormData, setSplitTargetFormData] = useState<any>(null);
    const [splitTargetFormVariables, setSplitTargetFormVariables] = useState<any>(null);
    const [splitExistingRecord, setSplitExistingRecord] = useState<any>(null);
    const [splitLoading, setSplitLoading] = useState<boolean>(false);

    const fileUploadFields = ["fileUpload", "fileUploadOCR", "imageCapture"];

    /**
 * on value change update form data
 * @param name 
 * @param value 
 * @param values 
 * @param fieldValues 
 * @returns 
 */
    function onValueChange(name, value, values, fieldValues = null) {
        if (name === 'editRecordsViewType') {
            setaction(value);
        }
        return [
            {
                ...values,
                [name]: value,
            },
        ];
    }

    /**
     * function call to Push code to editor
     */
    const addToEditor = (data) => {
        getTableJson(data)
    }

    useEffect(() => {

        // Filter `projectPermissionData` from `projectDataPerm` to find the permissions
        // related to the current project based on its ID.
        let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == props.projectData.id);

        // Initialize an empty object to store permissions.
        let permArray = {};

        // If permissions data (`perData`) exists and contains at least one item, 
        // process its `permissionData`.
        perData && perData[0]?.permissionData.forEach((obj) => {

            // If the current permission object has a key "Data":
            if (Object.keys(obj)[0] == "Data") {
                // Iterate over each item in the "Data" array.
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    // Map the `action` to its corresponding "allowed" permission's `is_selected` value.
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected;
                });

                // Uncommented line here could be used to set the "Data" permissions if needed.
                // setPermission(obj[Object.keys(obj)[0]]);

                // If the current permission object has a key "Forms":
            } else if (Object.keys(obj)[0] == "Forms") {
                // Iterate over each item in the "Forms" array.
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    // Map the `action` to its corresponding "allowed" permission's `is_selected` value.
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected;
                });
            }
        });

        // Set the processed permission data into the state using `setPermissionData`.
        setPermissionData(permArray);

        // Fetch data with the provided form ID, default page as 1, page size, and
        // permission for "all data view" from the processed permissions.
        if (props.allData && props.allData.isMaster) {

            setMasterDataForm(permArray)

        } else {

            setformData(props.formData)
            fetchRules(props.formData.id)
            fetchData(props.formData.id, 1, pageSize, permArray["all data view"]);
        }


    }, [refreshPage]); // Dependency array is empty, so this effect runs only once when the component mounts.


    const setMasterDataForm = async (permArray) => {
        let tempForms = await getForms(props.formData.form_group_id);

        let tempData = tempForms && tempForms.filter(itm => itm.form_use_category && itm.form_use_category.includes('Master'))
        if (props.formData && props.formData.id == tempData[0].id) {
            setformData(props.formData)
            fetchRules(props.formData.id)
            fetchData(props.formData.id, 1, pageSize, permArray["all data view"]);
        } else {
            tempData && setformData(tempData[0])
            fetchRules(tempData[0].id)
            fetchData(tempData[0].id, 1, pageSize, permArray["all data view"]);
        }
    }

    /**
     * 
     * @param id 
     * @param page 
     * @param size 
     * @param checkall 
     */
    // Fetch data From the api And set to the state. 
    const fetchData = async (id: any, page: number, size: number, checkall: any) => {
        try {
            dispatch(setLoading(true));
            setisPagination(true);
            setpageCount(props.formPageCount);
            let count = props.formPageCount / page;
            if (count < 10) {
                count = props.formPageCount - (page - 1) * 10;
            }

            let checkAllView = permissionData && permissionData['all data view'];
            let response = await getFormRecords(id, page, size, checkall);

            if (response.data && response.data.length > 0) {
                let tempHeaders: any[] = [];
                setresponseData(response.data);

                response.data.forEach((obj: any, index: number) => {
                    obj.fields.forEach((subObj: any) => {
                        if (index > 0) {
                            let check = tempHeaders.filter((elem: any) => elem.value === subObj.id);
                            if (check.length === 0) {
                                tempHeaders.push({
                                    label: subObj.field_name,
                                    value: subObj.id,
                                    data: subObj
                                });
                            }
                        } else {
                            tempHeaders.push({
                                label: subObj.field_name,
                                value: subObj.id,
                                data: subObj
                            });
                        }
                    });
                });

                tempHeaders.push({
                    label: "Total Score",
                    value: "total_score",
                    data: ""
                });

                tempHeaders.push({
                    label: "Duration",
                    value: "duration",
                    data: ""
                });

                let tempColumns: any = [];

                tempHeaders.forEach((obj: any) => {
                    tempColumns.push({
                        "id": obj.value,
                        "label": obj.label,
                        "data": obj.data,
                        accessor: (elem: any) => {
                            const field = elem.fields?.find((f: any) => f.id === obj.value);
                            const value = field?.field_selected_value;

                            if (obj.value === 'total_score') {
                                return elem.total_score || '-';
                            } else if (obj.value === 'duration') {
                                return elem.duration || '-';
                            } else if (fileUploadFields.includes(obj.data.field_type) && value) {
                                return <a
                                    className="link-text"
                                    href={`https://go.coguide.in/c1/download/${value}`}
                                    download
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Link
                                </a>
                            } else if (obj.data?.field_type === 'dateField' && value) {
                                return moment(value).format("YYYY-MM-DD");
                            } else if (obj.data?.field_type === 'time' && value) {
                                return convertUTCTimeToIST(value);
                            } else if (obj.value === 'select') {
                                return <input type='checkbox' onChange={() => console.log(value)} />;
                            } else if (obj.data?.field_type === 'password') {
                                return value ? "****" : '-';
                            } else {
                                return value?.toString() || '-';
                            }
                        },
                    });
                });

                setcolumns(tempColumns);

                let tempRecords: any = [];
                response.data.forEach((obj: any) => {
                    let tempRow: any = {
                        fields: obj.fields,
                        alertRules: obj?.alert || []
                    };

                    localStorage.setItem("timezone", obj.time_zone);

                    tempRow['total_score'] = obj.total_score || '-';

                    let ms = moment.utc(moment(obj.end_time, "YYYY-MM-DD HH:mm:ss").diff(moment(obj.start_time, "YYYY-MM-DD HH:mm:ss"))).format("HH:mm:ss");
                    let duration = moment.duration(ms);
                    tempRow['duration'] = (duration.hours() === 0 ? "" : duration.hours() + " Hrs ") + (duration.minutes() === 0 ? "" : duration.minutes() + " Min ") + (duration.seconds() === 0 ? "" : duration.seconds() + " Sec");

                    tempRecords.push(tempRow);
                });
                setrecords(tempRecords || []);
            } else {
                setresponseData([]);
                setrecords([]);
            }
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
            console.error("Error fetching data:", e);
        }
    };


    /**
     * 
     * @param type 
     * @param data 
     * onClick to handle each action on viewdata
     */
    const onAction = async (type, data: any = null, i: any = null) => {
        switch (type) {
            case 1:
                try {
                    dispatch(setLoading(true));
                    SetselectedIndex(data.index)
                    let response = await getFormVariables(props.formData.id);
                    if (response.data && response.data.length > 0) {
                        response.data.forEach((obj) => {
                            let selectedRecord = responseData[data.index].fields.filter(elem => elem.id === obj.id);
                            if (selectedRecord.length > 0) {
                                if (obj.field_type === 'dateField') {
                                    obj.selectedValue = new Date(selectedRecord[0].field_selected_value);
                                } else if (obj.field_type === 'dropDown') {
                                    obj.selectedValue = {
                                        label: selectedRecord[0].field_selected_value,
                                        value: selectedRecord[0].field_selected_value
                                    };
                                } else {
                                    obj.selectedValue = selectedRecord[0].field_selected_value;
                                }
                            }
                            obj.field_category = obj.field_category || 'empty';
                        });
                        let temp: any = _.groupBy(response.data, "field_category");
                        if (temp.empty) {
                            let data = cloneDeep(temp.empty);
                            delete temp.empty;
                            temp.empty = data;
                        }
                        setselectedRow(responseData[data.index]);
                        setformVariables(temp);
                        setaction('view');
                    }
                    dispatch(setLoading(false));
                } catch (e: any) {
                    dispatch(setLoading(false));
                }
                break;
            case 2:
                const state = { data: props.formData, projectData: props.projectData, selectedValues: responseData[data.index].fields, id: responseData[data.index].id, moduleType: "dataEntry" };
                onAction("navigateToDataEntry", state);
                break;
            case 3:
                setselectedRow(responseData[data.index]);
                setaction('delete');
                break;
            case 11:
                if (data == "all") {
                    SetSelectedRecords("all")
                } else {
                    SetSelectedRecords(Object.keys(data.selectedRowIds));
                }
                break;
            case 13:
                setaction("customerfilter");
                break;
            case 14:
                let checkAllView = permissionData && permissionData['all data view'];
                fetchData(props.formData.id, 1, pageSize, checkAllView);
                setcustomFilterData({});
                break;
            case 16:
                SetselectedIndex(data)
                setaction('survey')
                break;
            case 17:
                setactionPush("section")
                break;
            case 18:
                try {
                    dispatch(setLoading(true));
                    const response = await getVisualisationData(props.formData.id);
                    setVisualizationData(response.data);
                    setaction('visualize');
                    dispatch(setLoading(false));
                } catch (e: any) {
                    dispatch(setLoading(false));
                    showToaster(toasterTypes.ERROR, "Failed to fetch visualisation data.");
                }
                break;
            case "question":
                setaction("question")
                break;
            case "uploadstatus":
                setaction('uploadstatus')
                break;
            case "downloadstatus":
                setaction('downloadstatus')
                break;
            case "master":
                if (data?.checkMandatory) {
                    return;
                }
                SetselectedIndex(data)
                onAddMaster(data, "");
                break;
            case 'onViewSummary':
                console.log(data)
                SetselectedIndex(data)
                onViewRecordSummary(data);
                break;
            case "editRecords":
                selectedRecords.length ? setaction('editRecordsModal') : showToaster(toasterTypes.ERROR, "Please select records to edit");
                break;
            case "deleteRecords":
                setaction('deleteRecords');
                break;
            case "navigateToDataEntry":
                setCustomNavigationState(data);
                setaction(type);
                break;
            case "printPdf":
                setaction(type);
                break;
            case "splitView":
                if (isSplitView) {
                    setIsSplitView(false);
                    setSplitSelectedRecordIndex(null);
                    setSplitSelectedTargetForm("");
                    setSplitAction("");
                } else {
                    setIsSplitSelectionModalOpen(true);
                }
                break;
            default:
                setaction(type);
                break;
        }
    }


    /**
     * fetch list of rules for the selected form
     */
    const fetchRules = async (id) => {
        try {
            let response = await getRules(id);
            setRules(response && response.data)
        } catch (error) {
        }
    }

    /**
     * get form summary data
     * id and form id
     */
    const getSummaryForm = async (data) => {
        let uidData = data.uidData;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        let dataParams = [{
            "field_id": uidData?.id,
            "search_value": uidData?.field_selected_value.trim(),
            "field_type": uidData?.field_type,
            "time_zone": tz
        }
        ];
        try {
            dispatch(setLoading(true))
            let response = await getSummaryData(data.projectData.TopicID, props.formData.id, dataParams);
            if (response) {
                // setaction('addData')
                setaction('searchIndexMasterDataView')
                setSearchIndexUidData(dataParams)
                setmasterData(response.data)
                dispatch(setLoading(false))
            } else {

            }
        } catch (error) {
            dispatch(setLoading(false))

        }

    }
    /**
 * get custom filtered records
 * setisPagination : temporaraly hidding the pagination on custom filter
 */
    const getFilteredData = async (data, filterdata, page, customPageSize = null) => {
        try {
            SetPageNo(page);
            if (Object.keys(data).length != 0) {

                setcustomFilterData(filterdata);
                setcustomFormatedFilterData(data);
                dispatch(setLoading(true));

                if (data.search_data[0]?.field_type === "number") {
                    data.search_data[0].search_value = data.search_data[0]?.search_value;
                }

                let response = await getFilteredFormRecords(
                    props.formData.id,
                    data,
                    page,
                    customPageSize || pageSize,
                    permissionData['all data view']
                );

                let count = response.total_count && response.total_count[0]?.totalRecords;
                setpageCount(count || 0);

                if (response.data && response.data.length > 0) {
                    let tempHeaders: any = [];
                    setresponseData(response.data);

                    response.data.forEach((obj, index) => {
                        obj.fields.forEach(subObj => {
                            if (index > 0) {
                                let check = tempHeaders.filter(elem => elem.value === subObj.id);
                                if (check.length === 0) {
                                    tempHeaders.push({
                                        label: subObj.field_name,
                                        value: subObj.id,
                                        data: subObj
                                    });
                                }
                            } else {
                                tempHeaders.push({
                                    label: subObj.field_name,
                                    value: subObj.id,
                                    data: subObj
                                });
                            }
                        });
                    });

                    tempHeaders.push({
                        label: "Total Score",
                        value: "total_score",
                        data: ""
                    });

                    tempHeaders.push({
                        label: "Duration",
                        value: "duration",
                        data: ""
                    });

                    let tempColumns: any = [];

                    tempHeaders.forEach(obj => {
                        tempColumns.push({
                            "id": obj.value,
                            "label": obj.label,
                            "data": obj.data,
                            accessor: (elem: any) => {
                                const field = elem.fields?.find((f: any) => f.id === obj.value);
                                const value = field?.field_selected_value;

                                if (obj.value === 'total_score') {
                                    return elem.total_score || '-';
                                } else if (obj.value === 'duration') {
                                    return elem.duration || '-';
                                } else if (fileUploadFields.includes(obj.data.field_type) && value) {
                                    return <a
                                        className="link-text"
                                        href={`https://go.coguide.in/c1/download/${value}`}
                                        download
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        Link
                                    </a>
                                } else if (obj.data?.field_type === 'dateField' && value) {
                                    return moment(value).format("YYYY-MM-DD");
                                } else if (obj.data?.field_type === 'time' && value) {
                                    return convertUTCTimeToIST(value);
                                } else if (obj.value === 'select') {
                                    return <input type='checkbox' onChange={() => console.log(value)} />;
                                } else if (obj.data?.field_type === 'password') {
                                    return value ? "****" : '-';
                                } else {
                                    // Handle special case for TopicID C12195
                                    if (props.projectData.TopicID === "C12195") {
                                        return value?.toString() || '-';
                                    } else if (value === 'NA') {
                                        return '-';
                                    } else {
                                        return value?.toString() || '-';
                                    }
                                }
                            },
                        });
                    });

                    setcolumns(tempColumns);

                    let tempRecords: any = [];
                    response.data.forEach(obj => {
                        let tempRow: any = {
                            fields: obj.fields,
                            alertRules: obj?.alert || []
                        };

                        tempRow['total_score'] = obj.total_score || '-';

                        let ms = moment.utc(
                            moment(obj.end_time, "YYYY-MM-DD HH:mm:ss")
                                .diff(moment(obj.start_time, "YYYY-MM-DD HH:mm:ss"))
                        ).format("HH:mm:ss");

                        let duration = moment.duration(ms);
                        tempRow['duration'] =
                            (duration.hours() === 0 ? "" : duration.hours() + " Hrs ") +
                            (duration.minutes() === 0 ? "" : duration.minutes() + " Min ") +
                            (duration.seconds() === 0 ? "" : duration.seconds() + " Sec");

                        tempRecords.push(tempRow);
                    });

                    setrecords(tempRecords || []);
                } else {
                    setresponseData([]);
                    setrecords([]);
                }

                setaction('');
                dispatch(setLoading(false));
            }

            if (Object.keys(data).length == 0) {
                setcustomFilterData({});
                setcustomFormatedFilterData({});
                let checkAllView = permissionData && permissionData['all data view'];
                fetchData(props.formData.id, 1, customPageSize || pageSize, checkAllView);
            }
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    };

    /**
     * modify data on click modify button clicked
     * check if the action is from master data list depending on the record info
     * if yes than execute the if statment else
     * 
     */
    const onModify = async (record: any = null, index: any = null) => {
        let dataObj: any = props.formData;
        dataObj.projectData = props.projectData;
        if (record) {
            try {
                let responseForm = await getFormData(record.form_id);
                if (responseForm) {
                    let dataCurObj = responseForm.data;
                    dataCurObj.isMaster = true;
                    dataCurObj.masterData = masterData;
                    dataCurObj.projectData = props.projectData;
                    const state = { data: dataCurObj, projectData: props.projectData, selectedValues: record.fields, id: record.id, isMaster: true, moduleType: "dataEntry", modifyType: "modify", responseId: record.id };
                    onAction("navigateToDataEntry", state);
                }
            } catch (error) {

            }
        } else if (isMasterData) {
            try {
                let responseForm = await getFormData(masterresponseData.form_id);
                if (responseForm) {
                    let dataCurObj = responseForm.data;
                    dataCurObj.masterData = masterData;
                    dataCurObj.isMaster = true;
                    dataCurObj.projectData = props.projectData;
                    const state = { data: dataCurObj, projectData: props.projectData, selectedValues: masterresponseData.record_info[selectedIndex].fields, id: masterresponseData.record_info[selectedIndex].id, isMaster: true, moduleType: "dataEntry", modifyType: "modify", responseId: masterresponseData.record_info[selectedIndex].id };
                    onAction("navigateToDataEntry", state);
                }
            } catch (error) {

            }
        } else {
            dataObj.isMaster = true;
            dataObj.masterData = masterData;
            const state = { data: dataObj, projectData: props.projectData, selectedValues: isMasterData ? responseData[0] : responseData[selectedIndex].fields, id: isMasterData ? responseData[0].id : responseData[selectedIndex].id, moduleType: "dataEntry", modifyType: "modify", responseId: isMasterData ? responseData[0].id : responseData[selectedIndex].id };
            onAction("navigateToDataEntry", state);
        }
    }

    /**
     * partial modify the data
     */
    const onPartialModify = (record: any = null, index: any = null) => {
        props.formData.isPartialModify = true;
        const state = { data: props.formData, projectData: props.projectData, selectedValues: record.fields, id: record.id, moduleType: "dataEntry", modifyType: "modifyPartial", responseId: record.id };
        onAction("navigateToDataEntry", state);
    }

    /**
     * on Add action navigate to dataEntry
     */
    const onAdd = () => {
        let data: any = {
            created_on: props.formData.created_on,
            form_name: props.formData.form_name,
            id: props.formData.id,
            total_responses: props.formData.total_responses,
            updated_on: props.formData.updated_on
        };
        data.formsList = props.allForms || props.forms;
        data.projectData = props.projectData;
        const state = { data, projectData: props.projectData, moduleType: "dataEntry" };
        onAction("navigateToDataEntry", state);
    }

    //Get SourceUidField if present or first uid field
    const getSourceUidField = (fieldsData) => {
        const formid = props?.formData?.id;
        let flt = fieldsData.filter(itm => itm?.field_use_type?.includes('UID'));
        const sourceUidField = flt.find(itm => formid === itm?.source_form_id);
        let finalUidField;
        if (sourceUidField) {
            finalUidField = sourceUidField;
        } else {
            finalUidField = flt[0]
        }
        return finalUidField;
    }

    /**
   * on Add master popup action navigate to dataEntry
   */
    const onAddMaster = (selectedIndexData, uid: any = null) => {
        const uidFieldData = getSourceUidField(selectedIndexData.original.fields);
        let flt = selectedIndexData.original.fields.filter(itm => itm?.field_use_type?.includes('UID'));

        let data: any = {
            created_on: props.formData.created_on,
            total_responses: props.formData.total_responses,
            updated_on: props.formData?.updated_on,
            uidData: uidFieldData
        };

        data.formsList = props.allForms || props.forms;
        data.projectData = props.projectData;
        getSummaryForm(data)
    }

    const handleSplitViewModalProceed = async () => {
        const targetFormId = splitSelectedTargetForm?.value || splitSelectedTargetForm;
        if (!targetFormId) return;

        try {
            dispatch(setLoading(true));
            const formRes = await getFormData(targetFormId);
            setSplitTargetFormData(formRes.data);

            const varRes = await getFormVariables(targetFormId);
            setSplitTargetFormVariables(varRes.data);

            setIsSplitView(true);
            setIsSplitSelectionModalOpen(false);
            setSplitSelectedRecordIndex(null);

            // Set default action to data entry even with no UID selected
            setSplitAction("navigateToDataEntry");
            prepareEmptyDataEntryState(targetFormId);

        } catch (error) {
            console.error("Error setting up split view:", error);
            showToaster(toasterTypes.ERROR, "Failed to load target form details");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const prepareEmptyDataEntryState = (targetFormId) => {
        let selectedForm = (props.allForms || props.forms)?.find(f => f.id === targetFormId);

        let data: any = {
            created_on: selectedForm.created_on,
            form_name: selectedForm.form_name,
            id: selectedForm.id,
            total_responses: selectedForm.total_responses,
            updated_on: selectedForm.updated_on,
            uidData: null // No UID pre-selected
        };

        data.formsList = props.allForms || props.forms;
        data.projectData = props.projectData;
        data.isMaster = true;
        data.masterData = masterData;

        const state = { data, projectData: props.projectData, isMaster: true, moduleType: "dataEntry" };
        setSplitCustomNavigationState(state);
    }

    const checkExistingRecordForSplit = async (index) => {
        const targetFormId = splitSelectedTargetForm?.value || splitSelectedTargetForm;
        if (!targetFormId || !splitTargetFormVariables) return;

        try {
            setSplitLoading(true);
            setSplitSelectedRecordIndex(index);

            const masterRecord = responseData[index];
            const masterUidField = masterRecord.fields?.find(f => f.field_use_type?.includes('UID'));
            const masterUidValue = masterUidField?.field_selected_value;

            if (!masterUidValue) {
                showToaster(toasterTypes.WARNING, "Selected record has no UID");
                setSplitLoading(false);
                return;
            }

            const targetUidField = splitTargetFormVariables.find(v => v.field_use_type?.includes('UID'));
            if (!targetUidField) {
                // If no UID in target, maybe just show data entry
                setSplitAction("navigateToDataEntry");
                prepareDataEntryState(index);
                setSplitLoading(false);
                return;
            }

            const filterData = {
                search_data: [
                    {
                        field_id: targetUidField.id,
                        search_value: masterUidValue,
                        field_type: targetUidField.field_type,
                        is_field: true,
                        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone
                    }
                ]
            };

            const response = await getFilteredFormRecords(targetFormId, filterData, 1, 10, permissionData['all data view']);

            if (response.data && response.data.length > 0) {
                // Record found! Fetch variables for this specific record to show in view
                const record = response.data[0];
                const processedVariables = cloneDeep(splitTargetFormVariables);

                processedVariables.forEach((obj) => {
                    let selectedField = record.fields.find(elem => elem.id === obj.id);
                    if (selectedField) {
                        if (obj.field_type === 'dateField') {
                            obj.selectedValue = new Date(selectedField.field_selected_value);
                        } else if (obj.field_type === 'dropDown') {
                            obj.selectedValue = {
                                label: selectedField.field_selected_value,
                                value: selectedField.field_selected_value
                            };
                        } else {
                            obj.selectedValue = selectedField.field_selected_value;
                        }
                    }
                    obj.field_category = obj.field_category || 'empty';
                });

                let groupedVars: any = _.groupBy(processedVariables, "field_category");
                if (groupedVars.empty) {
                    let data = cloneDeep(groupedVars.empty);
                    delete groupedVars.empty;
                    groupedVars.empty = data;
                }

                setSplitExistingRecord({ record, variables: groupedVars });
                setSplitAction("view");
            } else {
                setSplitExistingRecord(null);
                setSplitAction("navigateToDataEntry");
                prepareDataEntryState(index);
            }
        } catch (error) {
            console.error("Error checking existing record:", error);
        } finally {
            setSplitLoading(false);
        }
    }

    const prepareDataEntryState = (index) => {
        const targetFormId = splitSelectedTargetForm?.value || splitSelectedTargetForm;
        let selectedForm = (props.allForms || props.forms)?.find(f => f.id === targetFormId);
        let record = responseData[index];
        let uidFieldData = getSourceUidField(record.fields);

        let data: any = {
            created_on: selectedForm.created_on,
            form_name: selectedForm.form_name,
            id: selectedForm.id,
            total_responses: selectedForm.total_responses,
            updated_on: selectedForm.updated_on,
            uidData: uidFieldData
        };

        data.formsList = props.allForms || props.forms;
        data.projectData = props.projectData;
        data.isMaster = true;
        data.masterData = masterData;

        const state = { data, projectData: props.projectData, isMaster: true, moduleType: "dataEntry" };
        setSplitCustomNavigationState(state);
    }

    /**
  * on View Info / View Summary popup when clicked on view summary
  */
    const onViewRecordSummary = async (selectedIndexData) => {
        const uidFieldData = getSourceUidField(selectedIndexData?.original.fields);

        let flt = selectedIndexData?.original.fields.filter(itm => itm?.field_use_type?.includes('UID'));

        let data: any = {
            created_on: props.formData.created_on,
            total_responses: props.formData.total_responses,
            updated_on: props.formData?.updated_on,
            uidData: uidFieldData
        };

        data.formsList = props.allForms || props.forms;
        data.projectData = props.projectData;
        let uidData = data.uidData;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const aiAgents: any = JSON.parse(localStorage.getItem("aiAgents") || "[]");
        const aiSummaryAgent: any = aiAgents.find((agent: any) => agent.name === agentNamesDataMap.ai_summary);

        let payload = {
            "search_data": {
                "field_id": uidData?.id,
                "search_value": uidData?.field_selected_value.trim(),
                "field_type": uidData?.field_type,
                "time_zone": tz,
            }
        }
        try {
            dispatch(setLoading(true))
            let masterUid = uidData?.field_selected_value.trim();
            let response = await getRecordSummary(masterUid, props.formData.id);
            if (response.status) {
                setaction('viewRecordSummary')
                setmasterData(response?.data?.summary)
            } else {
                let masterAiSummaryResponse = await getMasterAiSummary(payload, props.projectData.TopicID, props.formData.id, aiSummaryAgent?.id);
                showToaster(toasterTypes.SUCCESS, masterAiSummaryResponse?.message || '');
            }
        } catch (error) {
            showToaster(toasterTypes.ERROR, 'Unable to fetch summary data');
            setaction('');
        } finally {
            dispatch(setLoading(false))
        }
    }

    /**
     * on add master action
     */
    const onAddAction = (formitm) => {
        const uidFieldData = getSourceUidField(selectedIndex.cells);
        let data: any = {
            created_on: props.formData.created_on,
            form_name: formitm.form_name,
            id: formitm.form_id,
            total_responses: props.formData.total_responses,
            updated_on: props.formData.updated_on,
            uidData: uidFieldData
        };

        data.formsList = props.allForms || props.forms;
        data.projectData = props.projectData;
        data.isMaster = true;
        data.masterData = masterData;
        const state = { data, projectData: props.projectData, isMaster: true, moduleType: "dataEntry" };
        onAction("navigateToDataEntry", state);
    }

    /**
     * on view action
     */
    const onViewAction = async (record, index) => {
        try {
            dispatch(setLoading(true));
            let response = await getFormVariables(record.form_id);
            SetselectedIndex(index)
            setresponseData([record.record_info[index]])
            setisMasterData(true)
            setmasterresponseData(record)
            if (response.data && record.record_info.length > 0) {
                response.data.forEach((obj) => {
                    let selectedRecord = record.record_info[index].fields.filter(elem => elem.id === obj.id);

                    if (selectedRecord.length > 0) {
                        if (obj.field_type === 'dateField') {
                            obj.selectedValue = new Date(selectedRecord[0].field_selected_value);
                        } else if (obj.field_type === 'dropDown') {
                            obj.selectedValue = {
                                label: selectedRecord[0].field_selected_value,
                                value: selectedRecord[0].field_selected_value
                            };
                        } else {
                            obj.selectedValue = selectedRecord[0].field_selected_value;
                        }
                    }
                    obj.field_category = obj.field_category || 'empty';
                });
                let temp: any = _.groupBy(response.data, "field_category");
                if (temp.empty) {
                    let data = cloneDeep(temp.empty);
                    delete temp.empty;
                    temp.empty = data;
                }
                let responseForm = await getFormData(record?.form_id);
                setformData(responseForm?.data);
                setformVariables(temp);
                setselectedRow(record.record_info[index])
                setaction('view');
            }
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    }

    /**
     * Delete record and call to update table with refreshed data with @fetchData
     */
    const onDeleteRecords = async () => {
        const selectedRecordsIndexes = selectedRecords;
        const selectedRecordsArray = responseData.filter((record, index) => selectedRecordsIndexes.includes(String(index)));
        const selectedRecordsIds = selectedRecordsArray.map(record => ({ "id": record.id, "version_id": record.version_id, form_id: record.form_id, fields: record.fields }));
        try {
            dispatch(setLoading(true));
            const response = await deleteRecords(selectedRecordsIds);
            if (response.success) {
                setaction("");
                setRefreshPage(prev => prev + 1);
            }
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
            showToaster(toasterTypes.ERROR, "Failed to delete records.");
        }

    }

    /**
     * Delete record and call to update table with refreshed data with @fetchData
     */
    const onDelete = async () => {
        try {
            dispatch(setLoading(true));
            let response = await deleteRecord(selectedRow?.id);
            if (response.success) {
                setselectedRow(null);
                setaction('');
                showToaster(toasterTypes.SUCCESS, response.message);
                let checkAllView = permissionData && permissionData['all data view'];
                fetchData(props.formData.id, 1, pageSize, checkAllView);
                setisCallApi(true);
            } else {
                setaction("")
                showToaster(toasterTypes.INFO, response.message)
            }
            dispatch(setLoading(false));
        } catch (e: any) {

            dispatch(setLoading(false));
        }
    }

    /**
     * Download template with xlsx format
     */
    const downloadTemplate = async () => {
        try {
            dispatch(setLoading(true));
            let response = await downloadFieldTemplate(props.formData.id);
            var blob: any = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = "userInputData.xlsx";
            saveAs(blob, fileName)
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    }

    /**
     * Download data
     */
    const downloadData = async () => {
        try {
            //dispatch(setLoading(true));
            let response = await downloadFormData(props.formData.id);
            if (response.success) {
                showToaster(toasterTypes.SUCCESS, response.message)
            }
            // // await delay(2000);
            // const blob: any = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            // let link = document.createElement("a");
            // // let fileName = props.formData.form_name;
            // let fileName;
            // //if(response.head['content-type'] === "text/csv"){
            // fileName = props.formData.form_name + ".csv"
            // // }else{
            // //     fileName = props.formData.form_name
            // // }            
            // if (link.download !== undefined) {
            //     let url = window.URL.createObjectURL(blob);
            //     link.setAttribute("href", url);
            //     link.setAttribute("download", fileName);
            //     document.body.appendChild(link);
            //     link.click();
            //     // setTimeout(() => URL.revokeObjectURL(link.href), 10000 );
            //     document.body.removeChild(link);
            // }
            // dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    }


    /**
     * on click upload
     */
    const uploadFile = () => {
        setaction('')
        uploadFileRef.current?.click();
    }


    /**
     * uplaod data on OK response start event listener
     * @param e 
     */

    const onFileSelect = async (e) => {
        const file = e.target.files[0];
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Pre-upload validation for file size and type
        if (!file) {
            showToaster(toasterTypes.ERROR, "No file selected");
            return;
        }
        if (file.size > 50 * 1024 * 1024) { // Example: Limit file size to 10MB
            showToaster(toasterTypes.ERROR, "File size exceeds the 10MB limit");
            return;
        }
        if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/pdf', 'image/png', 'image/jpeg'].includes(file.type)) { // Example: Only allow specific file types
            showToaster(toasterTypes.ERROR, "Unsupported file type");
            return;
        }

        const formData = new FormData();
        formData.append('file', e.target.files[0]);
        formData.append('form_id', props.formData.id);
        formData.append("time_zone", tz);
        formData.append('overwrite', values['uploadtype'])
        formData.append('stoponerror', values['stoponerror'])

        // Validate token presence before proceeding
        const token = localStorage.getItem('coguide_token');
        if (!token) {
            showToaster(toasterTypes.ERROR, "User not authenticated. Please log in.");
            return;
        }

        try {
            try {
                const response = await uploadFileData(formData);
                if (response) {
                    showToaster(toasterTypes.SUCCESS, response.message)
                }
            } catch (err) {
                console.error("Error in SSE connection:", err);
            }



        } catch (error) {
            console.error("Error during file upload:", error);
            showToaster(toasterTypes.ERROR, "Unexpected error during file upload");
            SetUploadStatus(false);
        }
    };

    /**
     * @param e 
     */
    function onShowPageChange(e) {
        SetPageNo(e)
        if (Object.keys(customFilterData).length > 0) {
            getFilteredData(customFormatedFilterData, customFilterData, e)
        } else if (Object.keys(customFormatedFilterData).length > 0) {
            getFilteredData(customFormatedFilterData, customFilterData, e)
        } else {
            let checkAllView = permissionData && permissionData['all data view'];
            fetchData(props.formData.id, e, pageSize, checkAllView);
        }
    }

    /**
     * On Change number of record on each page 
     * @param current 
     * @param pagesize 
     */
    const handleSizeChange = (current, pagesize, searchData) => {
        SetPageSize(pagesize);
        let checkAllView = permissionData && permissionData['all data view'];
        getFilteredData(customFormatedFilterData, customFilterData, current, pagesize);
    };

    /**
     * On click Close Modal 
     */
    const onClose = () => {
        setaction('')
    }

    /**
     * create array of ids if multiselected
     * if selected all passing empty array as input
     * @param data 
     * API call
     */
    const generateLink = async (data) => {
        if (action == "survey") {
            let response = await getFormVariables(props.formData.id);
            let genUID = response && response.data.filter(item => item.field_use_type.includes("UID"));
            if (genUID.length > 0) {
                const uidVarId = genUID?.[0]?.id;

                const uidObj = selectedIndex?.original?.fields?.find(field => field.id === uidVarId);

                // ✅ Encode each value to avoid issues with spaces or special chars
                const topicId = encodeURIComponent(
                    props.projectData.TopicID || props.projectData.TopicCode
                );
                const formId = encodeURIComponent(data.value);
                const uid = encodeURIComponent(uidObj?.field_selected_value);
                const uidFieldId = encodeURIComponent(uidObj?.id);

                const url = `${surveyUrl}/surveyForm?topicId=${topicId}&formId=${formId}&uid=${uid}&uidFieldId=${uidFieldId}`;

                copyData(url, true);
                showToaster(toasterTypes.SUCCESS, "Link Copied Successfully");
            }
            else {
                showToaster(toasterTypes.INFO, "No Gen-UID field found in form");
            }
        } else {
            let idArray: any = [];
            selectedRecords.map(item => {
                idArray.push(responseData[item].id)
            })
            if (records.length === selectedRecords.length) {
                try {
                    dispatch(setLoading(true));
                    let response = await postgenerateLink(props.formData.id, data.value, []);
                    if (response) {
                        setaction("")
                        showToaster(toasterTypes.SUCCESS, "Emails sent with Links")
                    }
                    dispatch(setLoading(false));
                } catch (err: any) {
                    dispatch(setLoading(false));
                }
            } else {
                try {
                    dispatch(setLoading(true));
                    let response = await postgenerateLink(props.formData.id, data.value, idArray);
                    if (response) {
                        setaction("")
                        showToaster(toasterTypes.SUCCESS, "Emails sent with Links")
                    }
                    dispatch(setLoading(false));
                } catch (err: any) {
                    dispatch(setLoading(false));
                }
            }
        }
    }


    /**
     * function to push table data to editor
     * @htmlToJSON converts html table data to appropriate JSON format
     * @param data 
     */
    const getTableJson = (data) => {
        const table = document.querySelector('.custom-table');
        let response = htmlToJSON(table)
        response.then(tableData => {
            let pushResponse;
            tableData.map(item => {
                pushResponse = PushToEditor(item, data.section.value)
            })
            if (pushResponse) {
                showToaster(toasterTypes.SUCCESS, "Pushed code to editor")
            }
        })
        setactionPush("")
    };

    /**
     * action for Review and Approve
     */
    const actionRevApp = async (type, data) => {
        try {
            dispatch(setLoading(true));
            let response = await updateReviewApproveForm(data, type == "review" ? "r" : type == "approve" ? "a" : type == "rreview" ? "rr" : type == "rapprove" ? "ra" : "")
            if (response.success) {
                showToaster(toasterTypes.SUCCESS, type == "review" ? "Successfully confirmed review" : type == "approve" ? "Successfully approved" : type == "rreview" ? "Successfully reverted review" : type == "rapprove" ? "SUccessfully reverted approval" : "")
            }
            dispatch(setLoading(false));
        } catch (error) {
            dispatch(setLoading(false));
        }
    }

    return (
        action === 'navigateToDataEntry' ? <SurveyFormComponent {...customNavigationState} onClose={() => setaction('')} />
            :
            action === 'view' ?
                <ViewForm {...props} projectData={props.projectData} selectedRecord={selectedRow} variables={formVariables} formData={formData} modify={onModify} partialModify={onPartialModify} permissionData={permissionData} onClose={() => setaction('')} actions={actionRevApp} />
                :
                action === 'visualize' ? (
                    <div className="graphic-walker-visualization-container">
                        <GraphicWalkerVisualization formData={props?.formData} data={visualizationData} onClose={() => setaction('')} />
                    </div>
                ) :
                    action === "printPdf" ? (
                        <PrintPdfComponent formData={props?.formData} data={responseData} selectedRecords={selectedRecords} onClose={() => setaction('')} />
                    ) :
                        action === 'editRecordsVariableView' ? (
                            <EditRecordsVariableView records={responseData} selectedRecords={selectedRecords} formData={formData} onClose={() => setaction('')} />
                        ) :
                            action === 'editRecordsTableView' ? (
                                <EditRecordsTableView columns={columns} recs={records} records={responseData} selectedRecords={selectedRecords} formData={formData} onClose={() => setaction('')} />
                            ) :
                                action === "searchIndexMasterDataView" ? (
                                    <SearchIndexTabs
                                        existingData={masterData}
                                        getExistingData={(targetFormData, autofillData) => {
                                            const transformedData = {
                                                ...targetFormData,
                                                id: targetFormData.form_id
                                            };
                                            delete transformedData.form_id;
                                            const state = { data: transformedData, autofillData, projectData: props.projectData, selectedValues: targetFormData.fields, id: targetFormData.id, isMaster: true, moduleType: "dataEntry", modifyType: "searchIndexAutofill", responseId: targetFormData.id };
                                            onAction("navigateToDataEntry", state);
                                        }}
                                        topicId={props.projectData.TopicID}
                                        searchIndexUidData={searchIndexUidData}
                                        onClose={() => setaction('')}
                                        renderDataEntryForm={() => { }}
                                        renderType={"masterFlow"}
                                        projectData={props.projectData}
                                        forms={props.forms}
                                        formData={formData}
                                        selectedIndexData={selectedIndex}
                                        permissionData={permissionData}
                                        onRefresh={() => {
                                            if (selectedIndex && typeof selectedIndex === 'object') {
                                                onAddMaster(selectedIndex);
                                            } else {
                                                onAction('onViewSummary', selectedIndex);
                                            }
                                        }}
                                    />
                                ) :
                                    action === "addData" ? (
                                        <MasterData {...props} projectData={props.projectData} mdata={masterData} onClose={() => setaction('')} addAction={onAddAction} onModify={onModify} onAction={onViewAction} id={props.formData.id} selectedIndexData={selectedIndex} isMasterData={isMasterData} masterresponseData={masterresponseData} responseData={responseData} selectedRecord={selectedRow} variables={formVariables} formData={formData} permissionData={permissionData} />
                                    )
                                        :
                                        action === "viewRecordSummary" ? (
                                            <ViewRecordSummary {...props} projectData={props.projectData} mdata={masterData} onClose={() => setaction('')} id={props.formData.id} />
                                        )
                                            :
                                            <div className='view-form-data'>
                                                {
                                                    action === 'editRecordsModal' &&
                                                    <ModalComponent
                                                        width={"350px"}
                                                        isOpen={true}
                                                        onClose={() => setaction("")}
                                                        header={"Edit Records Views"}
                                                        centered={true}
                                                        customClass="edit-records-views-modal"
                                                        body={
                                                            <>
                                                                <div className="plan-template">
                                                                    <FieldItem
                                                                        name="editRecordsViewType"
                                                                        placeholder="Edit Records View Type"
                                                                        label=""
                                                                        type={FIELD_TYPES.RADIO_BUTTON}
                                                                        values={[
                                                                            { label: "Edit Records Table View", value: "editRecordsTableView" },
                                                                            { label: "Edit Records Variable View", value: "editRecordsVariableView" },
                                                                        ]}
                                                                        isMandatory={true}
                                                                        value={values.editRecordsViewType}
                                                                        onChange={(...e) =>
                                                                            handleChange('editRecordsViewType', ...e)
                                                                        }
                                                                        touched={fields.editRecordsViewType && fields.editRecordsViewType.hasError}
                                                                        error={fields.editRecordsViewType && fields.editRecordsViewType.errorMsg}
                                                                    />
                                                                </div>
                                                            </>
                                                        }
                                                        footer={<></>}
                                                    />

                                                }
                                                {action === 'editForm' &&
                                                    <CreateForm {...props} formData={props.formData} isEdit={true} projectData={props.projectData} groups={props.groups} group={props.groups[props.selectedGroup]} onClose={() => setaction('')} onFormCreation={() => props.onClose('forms')} />
                                                }
                                                {
                                                    action == "question" &&
                                                    <AskQuestions {...props} isClose={() => setaction("")} formId={props.formData.id} />
                                                }
                                                {
                                                    action === 'uid' &&
                                                    <UidGenerateLink {...props} projectData={props.projectData} variables={formVariables} formData={props.formData} modify={onModify} formList={props?.forms} onClose={() => setaction('')} onGenerate={generateLink} action={action} />
                                                }
                                                {
                                                    action == 'survey' &&
                                                    <UidGenerateLink {...props} projectData={props.projectData} variables={formVariables} formData={props.formData} modify={onModify} formList={props?.forms} onClose={() => setaction('')} onGenerate={generateLink} action={action} />
                                                }
                                                {
                                                    action == 'adduid' &&
                                                    <UidAddDataModal {...props} onViewRecordSummary={onViewRecordSummary} onAdd={onAddMaster} projectData={props.projectData} variables={formVariables} formData={props.formData} modify={onModify} formList={props?.forms} onClose={() => setaction('')} onGenerate={generateLink} action={action} />
                                                }
                                                {
                                                    action == 'uploadstatus' &&
                                                    <UploadStatusModal {...props} isClose={onClose} id={props.formData.id} />
                                                }
                                                {
                                                    action == 'downloadstatus' &&
                                                    <DownloadStatusModal {...props} isClose={onClose} id={props.formData.id} />
                                                }

                                                {
                                                    action === 'customerfilter' &&
                                                    <CustomFilter data={columns} submitAction={getFilteredData} onClose={onClose} filterdata={customFilterData} />
                                                }

                                                {
                                                    action === 'delete' &&
                                                    <ModalPopup
                                                        modalType='delete'
                                                        modalText={selectedRow.fields.map(item => { return item.field_selected_value + "   " })}
                                                        actionText="Are you sure, you want to delete? This action cannot be undone"
                                                        closeModal={() => { setaction(''); setselectedRow(null); }}
                                                        onAction={() => onDelete()}
                                                    />
                                                }
                                                {
                                                    action === 'deleteRecords' &&
                                                    <ModalPopup
                                                        modalType='delete'
                                                        actionText="Are you sure, you want to delete these records? This action cannot be undone"
                                                        closeModal={() => { setaction(''); setselectedRow(null); }}
                                                        onAction={() => onDeleteRecords()}
                                                    />
                                                }
                                                {
                                                    isSplitSelectionModalOpen &&
                                                    <ModalComponent
                                                        isOpen={true}
                                                        onClose={() => setIsSplitSelectionModalOpen(false)}
                                                        header={"Select Target Form for Split View"}
                                                        centered={true}
                                                        body={
                                                            <div className="p-3">
                                                                <FieldItem
                                                                    name="targetFormSplitModal"
                                                                    label="Select Target Form"
                                                                    type={FIELD_TYPES.DROP_DOWN}
                                                                    value={splitSelectedTargetForm}
                                                                    values={(props.allForms || props.forms)?.filter(f => f.id !== props.formData?.id)?.map(f => ({ label: f.form_name, value: f.id })) || []}
                                                                    onChange={(val) => setSplitSelectedTargetForm(val)}
                                                                />
                                                            </div>
                                                        }
                                                        footer={
                                                            <div className="d-flex justify-content-end p-2">
                                                                <CustomButton
                                                                    type="primary"
                                                                    text="Proceed"
                                                                    isDisabled={!splitSelectedTargetForm}
                                                                    onClick={handleSplitViewModalProceed}
                                                                />
                                                            </div>
                                                        }
                                                    />
                                                }

                                                {
                                                    action == "upload" &&
                                                    <ModalComponent
                                                        isOpen={true}
                                                        onClose={() => setaction('')}
                                                        header={"Select action todo"}
                                                        centered={true}
                                                        customClass="criteria-modal"
                                                        body={
                                                            <>
                                                                <Row>
                                                                    <Col md={12} className="mb-3">
                                                                        <FieldItem
                                                                            name='uploadtype'
                                                                            label="Select Upload Type"
                                                                            type={FIELD_TYPES.RADIO_BUTTON}
                                                                            value={values['uploadtype']}
                                                                            values={[{ value: "false", label: "Append Data" }, { value: "true", label: "Overwrite Data" }]}
                                                                            isListed={true}
                                                                            onChange={(...e) => {
                                                                                handleChange('uploadtype', ...e);
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={12} className="mb-3">
                                                                        <FieldItem
                                                                            name='stoponerror'
                                                                            label="On Error"
                                                                            type={FIELD_TYPES.RADIO_BUTTON}
                                                                            value={values['stoponerror']}
                                                                            values={[
                                                                                { value: "true", label: "Skip load on error" },
                                                                                { value: "false", label: "Skip error rows and load others" },
                                                                            ]}
                                                                            isListed={true}
                                                                            onChange={(...e) => {
                                                                                handleChange('stoponerror', ...e);
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        }
                                                        footer={
                                                            <>
                                                                <CustomButton type="primary" text="Procced" onClick={() => uploadFile()}></CustomButton>
                                                            </>
                                                        }
                                                    />
                                                }

                                                <div className='viewdata-body' style={{ height: props.isSummary ? "calc(100vh - 120px)" : "calc(100vh - 70px)" }}>
                                                    {isSplitView ? (
                                                        <div className="split-view-header no-print">
                                                            <CustomButton
                                                                type="primary-alt"
                                                                size="sm"
                                                                onClick={() => onAction("splitView")}
                                                                text="Exit Split View"
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className={window.innerWidth > 700 ? 'm-0 align-items-center actions-header' : 'm-0  actions-header-mobile'}>
                                                            <div className='pt-2'>
                                                                <div className='actions-text'>
                                                                    {
                                                                        window.innerWidth < 700 ?
                                                                            <ArrowLeftOutlined style={{ color: "#fff", fontSize: "28px", margin: "0px 10px" }} onClick={() => props.onClose(isCallApi ? 'forms' : '')} />
                                                                            : ""
                                                                    }
                                                                    {formData && formData.form_name}
                                                                </div>
                                                            </div>
                                                            <div className='p-0 m-0 actions-buttons'>

                                                                {
                                                                    window.innerWidth < 750 ?
                                                                        <div className={moreOption ? "more-options-open justify-content-end" : "more-options justify-content-end"} >
                                                                            {
                                                                                moreOption ?
                                                                                    <div className="more-container" onClick={() => setmoreOption(false)}>
                                                                                        <div className="form-actions">
                                                                                            {Object.keys(permissionData).length > 0 && !permissionData['add data'] ?
                                                                                                ""
                                                                                                :
                                                                                                <div className='add-data' onClick={() => onAdd()}>
                                                                                                    <i className='icon icon-add'></i>
                                                                                                    <span>Add Data</span>
                                                                                                </div>
                                                                                            }
                                                                                            {!props.formData.survey_form &&
                                                                                                <div className='icon-container'>
                                                                                                    {
                                                                                                        uploadStatus ?
                                                                                                            <Spinner type='grow' color='primary'> </Spinner>
                                                                                                            :
                                                                                                            <div className='upload-data' >
                                                                                                                <input type='file' value='' id="fileInput" ref={uploadFileRef} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" className='hide-input' onChange={(e) => { onFileSelect(e); }} />
                                                                                                                <i className='icon icon-upload' onClick={() => setaction('upload')} />
                                                                                                                Upload
                                                                                                            </div>
                                                                                                    }
                                                                                                </div>
                                                                                            }
                                                                                            {!props.formData.survey_form &&
                                                                                                <div className='status-data'>
                                                                                                    <ReloadOutlined style={{ color: "var(--primary-color, #006BD9)", padding: "0px 5px 0px 0px" }} onClick={() => onAction('uploadstatus', "")} /> Status
                                                                                                </div>
                                                                                            }

                                                                                            {
                                                                                                props?.formData?.form_use_category?.includes("UID form") ?
                                                                                                    <div className=' uid-data' onClick={() => { selectedRecords.length ? setaction('uid') : showToaster(toasterTypes.ERROR, "Please select records to generate UID") }}>
                                                                                                        <DatabaseFilled style={{ color: "var(--primary-color, #006BD9)", padding: "0px 5px 0px 0px" }} />
                                                                                                        UID
                                                                                                    </div>
                                                                                                    :
                                                                                                    ""
                                                                                            }
                                                                                            {
                                                                                                permissionData && Object.keys(permissionData).length > 0 && !permissionData['download template'] ?
                                                                                                    ""
                                                                                                    :
                                                                                                    <div className='icon-container downtemp-data' onClick={() => downloadTemplate()}>
                                                                                                        <FileExcelFilled style={{ color: "var(--primary-color, #006BD9)" }} />
                                                                                                        Template
                                                                                                        {/* <i className='icon icon-download' onClick={() => downloadTemplate()} /> */}
                                                                                                    </div>
                                                                                            }
                                                                                            {
                                                                                                Object.keys(permissionData).length > 0 && !permissionData['download'] ?
                                                                                                    ""
                                                                                                    :
                                                                                                    <div className='icon-container download-data' onClick={() => downloadData()}>
                                                                                                        <i className='icon icon-download' />
                                                                                                        Download
                                                                                                    </div>

                                                                                            }
                                                                                            {
                                                                                                <div className='icon-container' title='Get Download Status'>
                                                                                                    <>
                                                                                                    </>
                                                                                                    <div className='icon-container download-data' onClick={() => onAction('downloadstatus', "")}>
                                                                                                        <CloudDownloadOutlined />
                                                                                                        Download Status
                                                                                                    </div>

                                                                                                </div>
                                                                                            }
                                                                                            {
                                                                                                Object.keys(permissionData).length > 0 && !permissionData['edit form'] ?
                                                                                                    ""
                                                                                                    :
                                                                                                    <div className='icon-container edit-data' onClick={() => setaction('editForm')}>
                                                                                                        <i className='icon icon-edit' />
                                                                                                        Edit
                                                                                                    </div>
                                                                                            }

                                                                                        </div>

                                                                                    </div> : ""
                                                                            }

                                                                            <i className={moreOption ? "icon icon-close" : "icon icon-more"} onClick={() => setmoreOption(!moreOption)}></i>

                                                                        </div>
                                                                        :
                                                                        <>
                                                                            {Object.keys(permissionData).length > 0 && !permissionData['add data'] ?
                                                                                ""
                                                                                :
                                                                                <CustomButton type="alert-primary" onClick={() => onAdd()} className="w-100" text="Add Data"></CustomButton>
                                                                            }
                                                                            {!props.formData.survey_form &&
                                                                                <div className='icon-container' title='Upload File'>

                                                                                    <>
                                                                                        <input type='file' value='' id="fileInput" ref={uploadFileRef} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" className='hide-input' onChange={(e) => { onFileSelect(e); }} />
                                                                                        <i className='icon icon-upload' onClick={() => setaction('upload')} />

                                                                                    </>

                                                                                </div>
                                                                            }
                                                                            {!props.formData.survey_form &&
                                                                                <div className='icon-container' title='Get Upload Status'>
                                                                                    <>
                                                                                        <ReloadOutlined onClick={() => onAction('uploadstatus', "")} />
                                                                                    </>

                                                                                </div>
                                                                            }
                                                                            {props?.formData?.form_use_category?.includes("UID form") ?
                                                                                <div title='UID' className='icon-container' onClick={() => { selectedRecords.length ? setaction('uid') : showToaster(toasterTypes.ERROR, "Please select records to generate UID") }}>
                                                                                    UID
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            }
                                                                            {
                                                                                permissionData && Object.keys(permissionData).length > 0 && !permissionData['download template'] ?
                                                                                    ""
                                                                                    :
                                                                                    <div className='icon-container' title='Download Template'>
                                                                                        <FileExcelFilled onClick={() => downloadTemplate()} />
                                                                                        {/* <i className='icon icon-download' onClick={() => downloadTemplate()} /> */}
                                                                                    </div>
                                                                            }
                                                                            {
                                                                                Object.keys(permissionData).length > 0 && !permissionData['download'] ?
                                                                                    ""
                                                                                    :
                                                                                    <div className='icon-container' title='Download'>
                                                                                        <i className='icon icon-download' onClick={() => downloadData()} />
                                                                                    </div>

                                                                            }

                                                                            <div className='icon-container' title='Get Download Status'>
                                                                                <>
                                                                                    <CloudDownloadOutlined onClick={() => onAction('downloadstatus', "")} />
                                                                                </>
                                                                            </div>

                                                                            {
                                                                                Object.keys(permissionData).length > 0 && !permissionData['edit form'] ?
                                                                                    ""
                                                                                    :
                                                                                    <div className='icon-container' title='Edit Form'>
                                                                                        <i className='icon icon-edit' onClick={() => setaction('editForm')} />
                                                                                    </div>
                                                                            }
                                                                            <i className='icon icon-close' onClick={() => props.onClose(isCallApi ? 'forms' : '')} />

                                                                        </>
                                                                }

                                                            </div>
                                                        </div>
                                                    )}
                                                    {/* Split View Button moved to Table Buttons */}

                                                    {isSplitView ? (
                                                        <div className="split-view-container">
                                                            <div className="split-column col-uids">
                                                                <h5 className="column-header">UIDs</h5>
                                                                <div className="column-scroll-area" style={{ flex: 1, paddingBottom: '10px' }}>
                                                                    {responseData?.map((rec, index) => {
                                                                        let uidField = rec.fields?.find(f => f.field_use_type?.includes('UID'));
                                                                        let dispValue = uidField ? uidField.field_selected_value : `Record ${((pageNo - 1) * pageSize) + index + 1}`;
                                                                        return (
                                                                            <div
                                                                                key={rec.id}
                                                                                onClick={() => {
                                                                                    checkExistingRecordForSplit(index);
                                                                                }}
                                                                                className={`split-uid-item ${splitSelectedRecordIndex === index ? 'active' : ''}`}
                                                                            >
                                                                                {dispValue}
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                                {pageCount > pageSize && (
                                                                    <div className="split-pagination" style={{ padding: '10px 0', borderTop: '1px solid #eee', display: 'flex', justifyItems: 'center', justifyContent: 'center' }}>
                                                                        <Pagination
                                                                            simple
                                                                            onChange={(e) => onShowPageChange(e)}
                                                                            current={pageNo}
                                                                            total={pageCount}
                                                                            pageSize={pageSize}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="split-column col-details">
                                                                <h5 className="column-header">Detailed View</h5>
                                                                <div className="column-scroll-area">
                                                                    {splitSelectedRecordIndex !== null && responseData[splitSelectedRecordIndex] ? (
                                                                        responseData[splitSelectedRecordIndex].fields.map((field, idx) => {
                                                                            const isImageField = fileUploadFields.includes(field.field_type);
                                                                            const imageUrl = field.field_selected_value;

                                                                            return (
                                                                                <div key={`split-detail-${idx}`} className="split-detail-item">
                                                                                    <strong className="detail-label">{field.field_name}:</strong>
                                                                                    <span className="detail-value">
                                                                                        {isImageField && imageUrl ? (
                                                                                            <div className="detail-image-container">
                                                                                                <img
                                                                                                    src={`https://go.coguide.in/c1/download/${imageUrl}`}
                                                                                                    alt={field.field_name}
                                                                                                    onClick={() => {
                                                                                                        setMaximizedImageUrl(imageUrl);
                                                                                                        setMaximizedImageTitle(field.field_name);
                                                                                                        setIsImageMaximized(true);
                                                                                                    }}
                                                                                                />
                                                                                                <div
                                                                                                    className="fullscreen-icon"
                                                                                                    onClick={() => {
                                                                                                        setMaximizedImageUrl(imageUrl);
                                                                                                        setMaximizedImageTitle(field.field_name);
                                                                                                        setIsImageMaximized(true);
                                                                                                    }}
                                                                                                >
                                                                                                    <FullscreenOutlined />
                                                                                                </div>
                                                                                            </div>
                                                                                        ) : field.field_type === 'dateField' && field.field_selected_value ? (
                                                                                            moment(field.field_selected_value).format("YYYY-MM-DD")
                                                                                        ) : field.field_type === 'checkBox' ? (
                                                                                            Array.isArray(field.field_selected_value) ? field.field_selected_value.map(v => v.label || v.value || v).join(', ') : '-'
                                                                                        ) : typeof field.field_selected_value === 'object' && field.field_selected_value !== null ? (
                                                                                            field.field_selected_value.label || field.field_selected_value.value
                                                                                        ) : (
                                                                                            field.field_selected_value || '-'
                                                                                        )}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    ) : (
                                                                        <div className="split-empty-placeholder">Select a UID to view details</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="split-column col-entry">
                                                                <h5 className="column-header">{splitAction === 'view' ? 'Record Details' : 'Data Entry'}</h5>
                                                                <div className="column-scroll-area">
                                                                    {splitLoading ? (
                                                                        <div className="split-loading-container">
                                                                            <Spinner color="primary" />
                                                                        </div>
                                                                    ) : (splitSelectedRecordIndex !== null || splitAction === 'navigateToDataEntry') ? (
                                                                        splitAction === 'view' && splitExistingRecord ? (
                                                                            <div className="split-record-view">
                                                                                <div className="split-record-details">
                                                                                    {splitExistingRecord.record.fields.map((field, idx) => {
                                                                                        const isImageField = fileUploadFields.includes(field.field_type);
                                                                                        const imageUrl = field.field_selected_value;

                                                                                        return (
                                                                                            <div key={`split-target-detail-${idx}`} className="split-detail-item">
                                                                                                <strong className="detail-label">{field.field_name}:</strong>
                                                                                                <span className="detail-value">
                                                                                                    {isImageField && imageUrl ? (
                                                                                                        <div className="detail-image-container">
                                                                                                            <img
                                                                                                                src={`https://go.coguide.in/c1/download/${imageUrl}`}
                                                                                                                alt={field.field_name}
                                                                                                                onClick={() => {
                                                                                                                    setMaximizedImageUrl(imageUrl);
                                                                                                                    setMaximizedImageTitle(field.field_name);
                                                                                                                    setIsImageMaximized(true);
                                                                                                                }}
                                                                                                            />
                                                                                                            <div
                                                                                                                className="fullscreen-icon"
                                                                                                                onClick={() => {
                                                                                                                    setMaximizedImageUrl(imageUrl);
                                                                                                                    setMaximizedImageTitle(field.field_name);
                                                                                                                    setIsImageMaximized(true);
                                                                                                                }}
                                                                                                            >
                                                                                                                <FullscreenOutlined />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : field.field_type === 'dateField' && field.field_selected_value ? (
                                                                                                        moment(field.field_selected_value).format("YYYY-MM-DD")
                                                                                                    ) : field.field_type === 'checkBox' ? (
                                                                                                        Array.isArray(field.field_selected_value) ? field.field_selected_value.map(v => v.label || v.value || v).join(', ') : '-'
                                                                                                    ) : typeof field.field_selected_value === 'object' && field.field_selected_value !== null ? (
                                                                                                        field.field_selected_value.label || field.field_selected_value.value
                                                                                                    ) : (
                                                                                                        field.field_selected_value || '-'
                                                                                                    )}
                                                                                                </span>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                                <div className="split-record-actions mt-3 pt-3 border-top d-flex gap-2">
                                                                                    <CustomButton
                                                                                        type="primary"
                                                                                        text="Modify"
                                                                                        onClick={() => onModify(splitExistingRecord.record)}
                                                                                    />
                                                                                    <CustomButton
                                                                                        type="primary-alt"
                                                                                        text="Modify Partial"
                                                                                        onClick={() => onPartialModify(splitExistingRecord.record)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ) : splitAction === 'navigateToDataEntry' ? (
                                                                            <div className="data-entry-form-wrapper">
                                                                                <SurveyFormComponent
                                                                                    {...splitCustomNavigationState}
                                                                                    onClose={() => {
                                                                                        setSplitAction("");
                                                                                        setSplitSelectedRecordIndex(null);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="split-empty-placeholder">Checking record status...</div>
                                                                        )
                                                                    ) : (
                                                                        <div className="split-empty-placeholder">Select a UID to proceed</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{
                                                            padding: "1.5rem"
                                                        }}>
                                                            <CustomTable
                                                                header="Records"
                                                                data={records}
                                                                defaultdata={() => {
                                                                    return {
                                                                        Filter: ColumnFilter
                                                                    }
                                                                }}
                                                                tableProps={columns}
                                                                isPushToDoc={true}
                                                                isVisualize={true}
                                                                isSplitViewEnabled={true}
                                                                isEditRecords={false} //enable this to enable edit records
                                                                isCustomFilter={true}
                                                                isSort={true}
                                                                isSelect={true}
                                                                isFilter={false}
                                                                isSearch={false}
                                                                isEdit={false}
                                                                isSummary={true}
                                                                isEditable={false}
                                                                isDeleteRecords={true}
                                                                isPrintPdf={true}
                                                                isView={permissionData && Object.keys(permissionData).length > 0 && !permissionData['view data record'] ? false : true}
                                                                isDelete={permissionData && Object.keys(permissionData).length > 0 && !permissionData['delete data record'] ? false : true}
                                                                isCreate={false}
                                                                isSurvey={permissionData && Object.keys(permissionData).length > 0 && !permissionData['enable child survey link'] ? false : true}
                                                                getFilteredData={getFilteredData}
                                                                formId={props.formData.id}
                                                                isMaster={formData && formData?.form_use_category?.includes('Master') ? true : props.allData && props.allData.isMaster ? true : false}
                                                                previousFilterData={customFormatedFilterData}
                                                                onAction={(type, data = null) => onAction(type, data)}
                                                                rules={rules}
                                                                isNonBlocking={formData && formData?.form_use_category?.includes('MANDATORY') ? true : false}
                                                                onShowPageChange={onShowPageChange}
                                                                pageCount={pageCount}
                                                                currentPageNo={pageNo}
                                                                onShowSizeChange={handleSizeChange}
                                                                showPagination={true}
                                                            >
                                                            </CustomTable>
                                                        </div>
                                                    )}

                                                    {/* <div className='viewdata-pagination'>
                                                <Pagination onChange={(e) => onShowPageChange(e)} current={pageNo} total={pageCount} onShowSizeChange={handleSizeChange} />
                                            </div> */}
                                                    {isImageMaximized && (
                                                        <ModalComponent
                                                            isOpen={true}
                                                            onClose={() => setIsImageMaximized(false)}
                                                            header={maximizedImageTitle || "Image Preview"}
                                                            centered={true}
                                                            width="80%"

                                                            body={
                                                                <div style={{ textAlign: 'center', position: 'relative' }}>
                                                                    <img
                                                                        src={`https://go.coguide.in/c1/download/${maximizedImageUrl}`}
                                                                        alt="Full size preview"
                                                                        style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                                                                    />
                                                                </div>
                                                            }
                                                            footer={<></>}
                                                        />
                                                    )}
                                                    {
                                                        actionPush == "section" &&
                                                        <SectionModal pushAction={addToEditor} onclose={() => setactionPush("")} />
                                                    }
                                                </div>
                                            </div>
    )
}
